/**
 * A refusal from one of the services, keeping the stable `code` the error body may carry.
 *
 * The message is what the server chose to say and is fine to show; the code is what to branch
 * on, since wording changes and codes do not.
 */
export class ApiRequestError extends Error {
	readonly status: number | undefined
	readonly code: string | undefined

	constructor(message: string, status?: number, code?: string) {
		super(message)
		this.name = 'ApiRequestError'
		this.status = status
		this.code = code
	}
}

export const isApiRequestError = (error: unknown): error is ApiRequestError =>
	error instanceof ApiRequestError
